module.exports = __webpack_public_path__ + "static/firmyLogo-3885bfe195b58d1c048a0cda663047ce.png";